import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'about',
  metaInfo: {
    title: 'About Jybe'
  }  
})
export default class About extends Vue {
}
